import { Table, TableLoadingOverlay } from '@/components'
import { useTableSorting } from '@/hooks'
import { SortingState, Table as TanstackTable } from '@tanstack/react-table'
import { Dispatch, SetStateAction } from 'react'

type GHGEmissionsTableProps = {
    table: TanstackTable<unknown>
    isLoading: boolean
    sorting: SortingState
    setSorting: Dispatch<SetStateAction<SortingState>>
    loadingTitle?: string
    pagination?: React.ComponentProps<typeof Table>['pagination']
}

export const GHGEmissionsTable: React.FC<GHGEmissionsTableProps> = (props) => {
    const { isLoading, table, loadingTitle, setSorting, pagination } = props

    const { onTableColumnHeaderClick, getTableColumnSorting } = useTableSorting(
        table,
        setSorting
    )

    return (
        <div className="h-full">
            <div className="absolute inset-0 h-full w-full overflow-auto">
                <Table
                    table={table}
                    style="table"
                    onTableColumnHeaderClick={onTableColumnHeaderClick}
                    getColumnSorting={getTableColumnSorting}
                    pagination={pagination}
                />
            </div>
            <TableLoadingOverlay show={isLoading} title={loadingTitle} />
        </div>
    )
}
